/* ============================================================
 * CLEAN FETCH (bypasses third-party scripts on this store that
 * patch window.fetch AND XMLHttpRequest, causing errors like
 * "RestrictedUrlError" and "Cannot read properties of undefined
 * (reading 'M_ID')").
 *
 * A hidden same-origin iframe gets its own separate `window`,
 * untouched by scripts running in the parent page. Its fetch()
 * still resolves root-relative URLs (e.g. "/cart.js") against
 * the real page origin, and still sends cookies, so cart calls
 * work exactly like normal fetch — just without interference.
 * ============================================================ */
const cleanFetch = (function () {
  let fn = null;
  return function (url, options) {
    if (!fn) {
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      document.documentElement.appendChild(iframe);
      fn = iframe.contentWindow.fetch.bind(iframe.contentWindow);
    }
    return fn(url, options);
  };
})();


/* ============================================================
 * FILE INPUT LABEL RESET (shared by the ₹350 logo field and the
 * new cap logo field — both use the same .logo_embroidery_file_label
 * markup but are matched by `for` attribute so resetting one never
 * touches the other).
 * ============================================================ */
function resetFileLabel(inputId) {
  const $label = $('label[for="' + inputId + '"]');
  if (!$label.length) return;
  $label.removeClass('has-file');
  $label.find('.logo_embroidery_file_title').text('Choose File');
  $label.find('.logo_embroidery_file_text').text('Max 20 MB');
}

function setupFileInputLabel(inputId) {
  const fileInput = document.getElementById(inputId);
  const fileLabel = document.querySelector('label[for="' + inputId + '"]');
  if (!fileInput || !fileLabel) return;

  const uploadText = fileLabel.querySelector('.logo_embroidery_file_title');
  const uploadName = fileLabel.querySelector('.logo_embroidery_file_text');

  fileInput.addEventListener('change', function () {
    const file = this.files[0];
    fileLabel.classList.toggle('has-file', !!file);
    uploadText.textContent = file ? '✓ File Selected' : 'Choose File';
    uploadName.textContent = file ? file.name : 'Max 20 MB';
  });
}

document.addEventListener('DOMContentLoaded', function () {
  setupFileInputLabel('logo_embroidery_file');
  setupFileInputLabel('cap_logo_embroidery_file');
});


/* ============================================================
 * LOGO TYPE TOGGLE — DEFAULT ICON (cheap) vs CUSTOM LOGO (paid)
 * ============================================================
 * One generic helper, wired twice (main garment logo + cap logo)
 * since both follow the identical pattern: a radio picks between
 * a preset icon grid and the existing custom-upload field, only
 * one of which should ever add a product to cart. Gracefully does
 * nothing on templates that don't render this radio at all.
 */
function setupLogoTypeToggle(cfg) {
  const $radios = $('input[name="' + cfg.radioName + '"]');
  if (!$radios.length) return; // this template has no logo field of this kind

  const $iconGrid = $('#' + cfg.iconGridId);
  const $customUpload = $('#' + cfg.customUploadId);

  function updateVisibility() {
    const selected = $radios.filter(':checked').val();
    $iconGrid.toggle(selected === 'icon');
    $customUpload.toggle(selected === 'custom');
  }

  $radios.on('change', function () {
    updateVisibility();
    renderPersonaliseSummary();
  });

  $(document).on('click', '#' + cfg.iconGridId + ' .logo_icon_option', function () {
    $('#' + cfg.iconGridId + ' .logo_icon_option').removeClass('active');
    $(this).addClass('active');
    renderPersonaliseSummary();
    updateImagePreview();
  });

  updateVisibility();
}

function getSelectedIconName(gridId) {
  return document.querySelector('#' + gridId + ' .logo_icon_option.active')?.dataset.iconName || '';
}

function getLogoSummaryLine(cfg, label) {
  const selected = document.querySelector('input[name="' + cfg.radioName + '"]:checked')?.value;
  if (selected === 'icon') {
    const iconName = getSelectedIconName(cfg.iconGridId);
    if (iconName) return label + ' Icon: ' + iconName;
  } else if (selected === 'custom') {
    const file = document.getElementById(cfg.fileInputId)?.files?.[0];
    if (file) return label + ' Custom Logo: ' + file.name;
  }
  return null;
}

// Shared by both cap flows (the full Yes/No toggle flow and the
// standalone customisation_5 flow) so the icon-vs-custom logic for
// the cap logo only has to be written once.
async function addCapLogoAddon(quantity, groupId, typeSelected, iconId, iconName, file, customAddonId) {
  if (typeSelected === 'icon' && iconName && iconId) {
    const res = await cleanFetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: parseInt(iconId),
            quantity: quantity,
            properties: {
              'Icon': iconName,
              '_personalise_group': groupId,
              'Bundle ID': groupId
            }
          }
        ]
      })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => null);
      console.error('Cap logo icon addon failed:', err?.description || err);
    }
  } else if (typeSelected === 'custom' && file && customAddonId) {
    const formData = new FormData();
    formData.append('id', customAddonId);
    formData.append('quantity', String(quantity));
    formData.append('properties[_personalise_group]', groupId);
    formData.append('properties[Bundle ID]', groupId);
    formData.append('properties[Logo File]', file);

    const res = await cleanFetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    });
    if (!res.ok) {
      const err = await res.json().catch(() => null);
      console.error('Cap logo addon failed:', err?.description || err);
    }
  }
}

function resetLogoTypeToggle(cfg) {
  $('input[name="' + cfg.radioName + '"]').prop('checked', false);
  $('#' + cfg.iconGridId + ' .logo_icon_option').removeClass('active');
  $('#' + cfg.iconGridId).hide();
  $('#' + cfg.customUploadId).hide();
}

document.addEventListener('DOMContentLoaded', function () {
  setupLogoTypeToggle({
    radioName: 'logo_type_select',
    iconGridId: 'logo_icon_grid',
    customUploadId: 'logo_custom_upload'
  });

  setupLogoTypeToggle({
    radioName: 'cap_logo_type_select',
    iconGridId: 'cap_logo_icon_grid',
    customUploadId: 'cap_logo_custom_upload'
  });
});









const THREAD_COLOR_HEX = {
  'Black': '#090909',
  'Red': '#ea0f0f',
  'Blue': '#060c89',
  'Pink': '#ce0297',
  'White': '#ffffff',
  'Yellow': '#ffed10',
  'Orange': '#f98403',
  'Green': '#05cc2a'
};

const FONT_FAMILY_MAP = {
  'Block': 'Urbane',
  'Script': 'ChallengeBoldStd'
};

function updateImagePreview() {
  const $textWrap = $('#m_preview_text');
  const $line1 = $('#m_preview_text_line1');
  const $line2 = $('#m_preview_text_line2');

  if (!$textWrap.length) return; // this template has no preview image block

  const top1 = ($('#name_on_top_line_1').val() || '').trim();
  const top2 = ($('#name_on_top_line_2').val() || '').trim();
  const threadColor = $('input[name="thread_color"]:checked').val();
  const fontType = $('input[name="field_fontType"]:checked').val();

  const color = THREAD_COLOR_HEX[threadColor] || '#ffff';
  const fontFamily = FONT_FAMILY_MAP[fontType] || 'Urbane';

  $line1.text(top1).css({ color: color, fontFamily: fontFamily });
  $line2.text(top2).css({ color: color, fontFamily: fontFamily });

  $textWrap.toggle(!!(top1 || top2));

  // LOGO / ICON — left side. Works for icon grid selection OR
  // custom uploaded file, whichever is currently active.
  const $logoWrap = $('#m_preview_logo');
  const $logoImg = $('#m_preview_logo_img');

  const logoTypeSelected = $('input[name="logo_type_select"]:checked').val();

  if (logoTypeSelected === 'icon') {
    const $activeIcon = $('#logo_icon_grid .logo_icon_option.active img');
    if ($activeIcon.length) {
      $logoImg.attr('src', $activeIcon.attr('src'));
      $logoWrap.show();
    } else {
      $logoWrap.hide();
    }
  } else if (logoTypeSelected === 'custom') {
    const file = document.getElementById('logo_embroidery_file')?.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = function (e) {
        $logoImg.attr('src', e.target.result);
        $logoWrap.show();
      };
      reader.readAsDataURL(file);
    } else {
      $logoWrap.hide();
    }
  } else {
    $logoWrap.hide();
  }
}

// Hook into the same events that already trigger the summary —
// keeps preview in sync without touching existing listeners.
$(document).on(
  'input change',
  '#name_on_top_line_1, #name_on_top_line_2, input[name="thread_color"], input[name="field_fontType"], input[name="logo_type_select"], #logo_embroidery_file',
  updateImagePreview
);


document.addEventListener('DOMContentLoaded', updateImagePreview);





/* ============================================================
 * CLEAR PERSONALISE FIELDS (main product)
 * ============================================================
 * Reused after a successful add-to-cart, on variant change, and
 * when "no-personalise" is chosen — so leftover name/thread/logo
 * data never silently carries over to a different variant or a
 * later, unrelated add.
 */
function clearPersonaliseFields() {
  $('#name_on_top_line_1, #name_on_top_line_2, #name_on_bottom_line_1').val('');
  $('input[name="thread_color"]').prop('checked', false);
  $('input[name="field_fontType"]').prop('checked', false);
  $('#addon_199_yes').prop('checked', false).trigger('change');

  // Also clear the selected state on the "Personalise" option box
  // itself, since the entered data is gone.
  $('.personalise_scrubs_box_option[data-action="personalise"]').removeClass('active');

  const $fileInput = $('#logo_embroidery_file');
  if ($fileInput.length) {
    $fileInput.val('');
  }
  resetFileLabel('logo_embroidery_file');
  resetLogoTypeToggle({
    radioName: 'logo_type_select',
    iconGridId: 'logo_icon_grid',
    customUploadId: 'logo_custom_upload'
  });

  // Matching cap block gets reset together with everything else —
  // it's part of the same bundle, so a full reset shouldn't leave
  // stale cap data behind.
  $('#capaddon_275_yes, #capaddon_275_select_no').prop('checked', false);
  clearCapFields();

  renderPersonaliseSummary();
  updateImagePreview();
}

/* ============================================================
 * CLEAR CAP FIELDS
 * ============================================================
 * Separate from clearPersonaliseFields() so the "No" radio for
 * the matching cap can clear just its own fields without
 * touching the main personalisation state.
 */
function clearCapFields() {
  $('#name_on_cap_line_1').val('');
  const $capFileInput = $('#cap_logo_embroidery_file');
  if ($capFileInput.length) {
    $capFileInput.val('');
  }
  resetFileLabel('cap_logo_embroidery_file');
  resetLogoTypeToggle({
    radioName: 'cap_logo_type_select',
    iconGridId: 'cap_logo_icon_grid',
    customUploadId: 'cap_logo_custom_upload'
  });
}

$(document).on('change', '#capaddon_275_select_no', function () {
  if ($(this).is(':checked')) {
    clearCapFields();
    renderPersonaliseSummary();
  }
});


/* ============================================================
 * LIVE PERSONALISATION SUMMARY
 * ============================================================
 * Shows whatever the customer has filled in (names, thread
 * colour, logo file, matching cap) just below the CUSTOMIZATION
 * box, updating live as fields change.
 */
function getPersonaliseSummaryLines() {
  const lines = [];

  const isPersonaliseChosen = $('.personalise_scrubs_box_option[data-action="personalise"]').hasClass(
    'active'
  );

  if (isPersonaliseChosen) {
    const top1 = ($('#name_on_top_line_1').val() || '').trim();
    const top2 = ($('#name_on_top_line_2').val() || '').trim();
    if (top1) lines.push('Name On Top - Line 1: ' + top1);
    if (top2) lines.push('Name On Top - Line 2: ' + top2);
    const threadColor = $('input[name="thread_color"]:checked').val();
    if (threadColor) lines.push('Thread Color: ' + threadColor);
    const field_fontType = $('input[name="field_fontType"]:checked').val();
    if (field_fontType) lines.push('Font: ' + field_fontType);

    if ($('#addon_199_yes').is(':checked')) {
      const bottom1 = ($('#name_on_bottom_line_1').val() || '').trim();
      if (bottom1) lines.push('Name On Bottom - Line 1: ' + bottom1);

      // const threadColor = $('input[name="thread_color"]:checked').val();
      // if (threadColor) lines.push('Thread Color: ' + threadColor);
    }

    const logoLine = getLogoSummaryLine(
      { radioName: 'logo_type_select', iconGridId: 'logo_icon_grid', fileInputId: 'logo_embroidery_file' },
      'Logo'
    );
    if (logoLine) lines.push(logoLine);
  }

  // Matching cap lines are independent of the main personalise
  // toggle above — a customer can add a plain matching cap even
  // if they didn't personalise the scrubs themselves.
  const $capYesRadio = $('#capaddon_275_yes');
  const hasCapToggle = $capYesRadio.length > 0;

  const capCfg = { radioName: 'cap_logo_type_select', iconGridId: 'cap_logo_icon_grid', fileInputId: 'cap_logo_embroidery_file' };

  if (hasCapToggle) {
    if ($capYesRadio.is(':checked')) {
      lines.push('Matching Scrub Cap: Yes');

      const capName = ($('#name_on_cap_line_1').val() || '').trim();
      if (capName) lines.push('Name On Cap: ' + capName);

      const capLogoLine = getLogoSummaryLine(capCfg, 'Cap');
      if (capLogoLine) lines.push(capLogoLine);
    }
  } else {
  const capName = ($('#name_on_cap_line_1').val() || '').trim();
  if (capName) lines.push('Name On Cap: ' + capName);

  const capLogoLine = getLogoSummaryLine(capCfg, 'Cap');
  if (capLogoLine) lines.push(capLogoLine);
}

  return lines;
}

function renderPersonaliseSummary() {
  let $summary = $('#personalise_live_summary');

  if (!$summary.length) {
    $summary = $('<div id="personalise_live_summary"></div>')
    $('.personalise_scrubs_box').after($summary);
  }

  const lines = getPersonaliseSummaryLines();
  $summary.empty();

  if (!lines.length) {
    $summary.hide();
    return;
  }

  $summary.show().append($('<strong>').text('Your Personalisation Details'));
  lines.forEach(function (line) {
    $summary.append($('<div>').text(line));
  });

  const $actions = $('<div class="personalise_summary_actions"></div>');

  $actions.append(
    $('<button type="button" class="personalise_summary_edit"></button>')
      .html('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.06 3.59L20.41 4.94C21.2 5.72 21.2 6.99 20.41 7.77L7.18 21H3V16.82L13.4 6.41L16.23 3.59C17.01 2.81 18.28 2.81 19.06 3.59ZM5 19L6.41 19.06L16.23 9.23L14.82 7.82L5 17.64V19Z" fill="currentColor"></path></svg>')
  );

  $actions.append(
    $('<button type="button" class="personalise_summary_reset"></button>')
      .html('<svg width="28px" height="28px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="Product-Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="ic_fluent_delete_48_regular" fill="#212121" fill-rule="nonzero"> <path d="M24,7.25 C27.1017853,7.25 29.629937,9.70601719 29.7458479,12.7794443 L29.75,13 L37,13 C37.6903559,13 38.25,13.5596441 38.25,14.25 C38.25,14.8972087 37.7581253,15.4295339 37.1278052,15.4935464 L37,15.5 L35.909,15.5 L34.2058308,38.0698451 C34.0385226,40.2866784 32.1910211,42 29.9678833,42 L18.0321167,42 C15.8089789,42 13.9614774,40.2866784 13.7941692,38.0698451 L12.09,15.5 L11,15.5 C10.3527913,15.5 9.8204661,15.0081253 9.75645361,14.3778052 L9.75,14.25 C9.75,13.6027913 10.2418747,13.0704661 10.8721948,13.0064536 L11,13 L18.25,13 C18.25,9.82436269 20.8243627,7.25 24,7.25 Z M33.4021054,15.5 L14.5978946,15.5 L16.2870795,37.8817009 C16.3559711,38.7945146 17.116707,39.5 18.0321167,39.5 L29.9678833,39.5 C30.883293,39.5 31.6440289,38.7945146 31.7129205,37.8817009 L33.4021054,15.5 Z M27.25,20.75 C27.8972087,20.75 28.4295339,21.2418747 28.4935464,21.8721948 L28.5,22 L28.5,33 C28.5,33.6903559 27.9403559,34.25 27.25,34.25 C26.6027913,34.25 26.0704661,33.7581253 26.0064536,33.1278052 L26,33 L26,22 C26,21.3096441 26.5596441,20.75 27.25,20.75 Z M20.75,20.75 C21.3972087,20.75 21.9295339,21.2418747 21.9935464,21.8721948 L22,22 L22,33 C22,33.6903559 21.4403559,34.25 20.75,34.25 C20.1027913,34.25 19.5704661,33.7581253 19.5064536,33.1278052 L19.5,33 L19.5,22 C19.5,21.3096441 20.0596441,20.75 20.75,20.75 Z M24,9.75 C22.2669685,9.75 20.8507541,11.1064548 20.7551448,12.8155761 L20.75,13 L27.25,13 C27.25,11.2050746 25.7949254,9.75 24,9.75 Z" id="🎨-Color"></path> </g> </g> </svg>')
  );

  $summary.append($actions);
}

// Edit — reopen the personalise popup so the customer can change
// what they entered.
$(document).on('click', '.personalise_summary_edit', function (e) {
  e.preventDefault();
  $('.m-product-custom_popup, .m-product-custom_popup_overlay').addClass('active');
});

// Reset — clear everything entered so far (including the cap
// block), and bring back the customization box in case it was
// hidden after a submit.
$(document).on('click', '.personalise_summary_reset', function (e) {
  e.preventDefault();
  clearPersonaliseFields();
  $('.personalise_scrubs_box').show();
});

$(document).on(
  'input change',
  '#name_on_top_line_1, #name_on_top_line_2, #name_on_bottom_line_1, input[name="thread_color"], input[name="field_fontType"], #addon_199_yes, #logo_embroidery_file, #capaddon_275_yes, #capaddon_275_select_no, #name_on_cap_line_1, #cap_logo_embroidery_file',
  renderPersonaliseSummary
);

document.addEventListener('DOMContentLoaded', renderPersonaliseSummary);


/* ============================================================
 * PERSONALISE POPUP TOGGLE
 * ============================================================ */
$(document).on('click', '.personalise_scrubs_box_option', function () {
  const $option = $(this);
  const $popup = $('.m-product-custom_popup, .m-product-custom_popup_overlay');
  const action = $option.data('action');

  $('.personalise_scrubs_box_option').removeClass('active');
  $option.addClass('active');

  if (action === 'personalise') {
    $popup.addClass('active');
    const $yes = $('#po_stack295152 input#po_button0[name="po_button295152"]');
    if (!$yes.prop('checked')) $yes.prop('checked', true).trigger('change');
  }

  if (action === 'no-personalise') {
    $popup.removeClass('active');
    const $no = $('#po_stack295152 input#po_button1[name="po_button295152"]');
    if (!$no.prop('checked')) $no.prop('checked', true).trigger('change');

    clearPersonaliseFields();
  }

  renderPersonaliseSummary();
});

$(document).on(
  'click',
  '.m-product-custom_popup_overlay, .m-product-custom_popup_close, .m-product-custom-field_button',
  function () {
    $('.m-product-custom_popup, .m-product-custom_popup_overlay').removeClass('active');
  }
);


/* ============================================================
 * SHARED: REFRESH CART DRAWER + ICON BUBBLE
 * ============================================================
 * "latest wins" guard — if refreshCartUI() gets called again
 * before an earlier call's fetch has resolved, the earlier
 * (now-stale) response is discarded instead of overwriting the
 * DOM with old data. This is what was causing the cart count to
 * flicker / disappear intermittently.
 */
let refreshCartUIToken = 0;

async function refreshCartUI() {
  const myToken = ++refreshCartUIToken;

  try {
    const [sectionsResponse, cartResponse] = await Promise.all([
      cleanFetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble', {
        cache: 'no-store'
      }),
      cleanFetch(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' })
    ]);
    const sections = await sectionsResponse.json();
    const cart = await cartResponse.json();

    if (myToken !== refreshCartUIToken) return;

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && sections['cart-drawer']) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = sections['cart-drawer'];
      const newCartDrawer = tempDiv.querySelector('cart-drawer');
      if (newCartDrawer) {
        cartDrawer.innerHTML = newCartDrawer.innerHTML;

        cartDrawer.classList.toggle(
          'is-empty',
          newCartDrawer.classList.contains('is-empty')
        );

        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          cartDrawer.classList.add('active');
        }
      }
    }

    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble && sections['cart-icon-bubble']) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = sections['cart-icon-bubble'];

      const sectionRoot =
        tempDiv.querySelector('.shopify-section') || tempDiv.firstElementChild;

      if (sectionRoot) {
        cartIconBubble.innerHTML = sectionRoot.innerHTML;
      }
    }

    applyGroupDecoration(cart);
  } catch (error) {
    console.error('Cart refresh error:', error);
  }
}


/* ============================================================
 * ADD TO CART (main + ₹199 addon + ₹350 logo addon +
 * ₹275 matching cap + ₹100 cap name + ₹350 cap logo)
 * ============================================================
 * All six possible line items share ONE group ID, so the whole
 * bundle (scrubs + cap) moves, syncs quantity, and gets removed
 * together in the cart.
 */
document.addEventListener('DOMContentLoaded', function () {
  const addToCartBtn = document.querySelector('[name="add"]');
  const form = document.querySelector('form[action="/cart/add"]');
  if (!addToCartBtn || !form) return;

  // Variant changed (Dawn updates the hidden id input on selection)
  // — clear any personalise/cap data entered for the previous variant.
  const variantIdInput = form.querySelector('input[name="id"]');
  if (variantIdInput) {
    let lastVariantId = variantIdInput.value;
    new MutationObserver(function () {
      if (variantIdInput.value !== lastVariantId) {
        lastVariantId = variantIdInput.value;
        clearPersonaliseFields();
      }
    }).observe(variantIdInput, { attributes: true, attributeFilter: ['value'] });

    variantIdInput.addEventListener('change', function () {
      if (this.value !== lastVariantId) {
        lastVariantId = this.value;
        clearPersonaliseFields();
      }
    });
  }

  addToCartBtn.addEventListener('click', async function (e) {
    e.preventDefault();

    const spinner = addToCartBtn.querySelector('.loading__spinner');
    addToCartBtn.setAttribute('aria-disabled', 'true');
    addToCartBtn.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');

    try {
      const addon199Id = document.getElementById('addon_199_id')?.value;
      const addon350Id = document.getElementById('addon_350_id')?.value;
      const is199Selected = document.getElementById('addon_199_yes')?.checked;

      // LOGO — icon (cheap) vs custom upload (paid). If this
      // template doesn't render the toggle at all, logoTypeSelected
      // stays undefined and neither branch fires later.
      const logoTypeSelected = document.querySelector('input[name="logo_type_select"]:checked')?.value;
      const logoIconId = document.getElementById('logo_icon_id')?.value;
      const logoIconName = getSelectedIconName('logo_icon_grid');
      const logoFile = document.getElementById('logo_embroidery_file')?.files?.[0];

      const nameTop1 = document.getElementById('name_on_top_line_1')?.value || '';
      const nameTop2 = document.getElementById('name_on_top_line_2')?.value || '';

      // If this product's template renders the PAID "Name On Top"
      // block, it carries this hidden id. On the old free template
      // this element simply doesn't exist — that presence check is
      // all we need to tell the two templates apart, no class needed.
      const nameTopAddonId = document.getElementById('name_on_top_addon_id')?.value;
      const isNameTopPaid = !!nameTopAddonId;

      const nameBottom1 = document.getElementById('name_on_bottom_line_1')?.value || '';
      const threadColor =
        document.querySelector('input[name="thread_color"]:checked')?.value;
      const field_fontType =
        document.querySelector('input[name="field_fontType"]:checked')?.value;

      // matching cap fields
      const matchingCap275Id = document.getElementById('matching_cap_275_id')?.value;
      const capAddon100Id = document.getElementById('cap_addon_100_id')?.value;
      const capAddon350Id = document.getElementById('cap_addon_350_id')?.value;
      const capYesRadio = document.getElementById('capaddon_275_yes');
      const isCapSelected = capYesRadio?.checked;
      const capNameLine1 = document.getElementById('name_on_cap_line_1')?.value || '';

      // CAP LOGO — icon (cheap) vs custom upload (paid), same
      // pattern as the main logo above.
      const capLogoTypeSelected = document.querySelector('input[name="cap_logo_type_select"]:checked')?.value;
      const capLogoIconId = document.getElementById('cap_logo_icon_id')?.value;
      const capLogoIconName = getSelectedIconName('cap_logo_icon_grid');
      const capLogoFile = document.getElementById('cap_logo_embroidery_file')?.files?.[0];

      // customisation_3 has no Yes/No radio at all — just the cap
      // name field on its own. Its presence/absence is what tells
      // the two cap templates apart, same pattern as Name On Top.
      const hasCapToggle = !!capYesRadio;

      const mainVariantId = new FormData(form).get('id');

      if (!mainVariantId) {
        console.error('Main variant ID not found');
        return;
      }

      // Respect the quantity selector on the page instead of
      // always adding 1 — main + every addon should all match it.
      const quantity =
        parseInt(form.querySelector('input[name="quantity"]')?.value) || 1;

      // ONE GROUP ID — main + 199 + 350 + cap + cap-name + cap-logo
      // all share it.
      const groupId =
        'personalise_' + Date.now() + '_' + Math.random().toString(36).substring(2, 9);

      const mainProperties = {
        '_personalise_group': groupId,
        'Bundle ID': groupId,
      };
      
      if (threadColor) mainProperties['Thread Color'] = threadColor;
      if (field_fontType) mainProperties['Font'] = field_fontType;
      // Free template (old customisation_2): Name On Top rides
      // along as a property on the main product itself — no charge.
      if (!isNameTopPaid) {
        if(nameTop1 !== "") mainProperties['Name On Top - Line 1'] = nameTop1;
        if(nameTop2 !== "") mainProperties['Name On Top - Line 2'] = nameTop2;
      }

      // MAIN PRODUCT — its own request, so a later addon failure
      // (or the reverse) never blocks the other.
      const mainResponse = await cleanFetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: parseInt(mainVariantId),
              quantity: quantity,
              properties: mainProperties
            }
          ]
        })
      });

      if (!mainResponse.ok) {
        const err = await mainResponse.json().catch(() => null);
        console.error('Main product add failed:', err?.description || err);
        return;
      }

      // NAME ON TOP ADDON (paid template only) — separate request.
      // Only fires when this product's template uses the paid Name
      // On Top block, and only if the customer actually typed a name.
      if (isNameTopPaid && (nameTop1.trim() || nameTop2.trim())) {
        const nameTopResponse = await cleanFetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: parseInt(nameTopAddonId),
                quantity: quantity,
                properties: {
                  'Name On Top - Line 1': nameTop1,
                  'Name On Top - Line 2': nameTop2,
                  '_personalise_group': groupId,
                  'Bundle ID': groupId
                }
              }
            ]
          })
        });

        if (!nameTopResponse.ok) {
          const err = await nameTopResponse.json().catch(() => null);
          console.error('Name on top addon failed:', err?.description || err);
        }
      }

      // ₹199 ADDON — separate request
      if (is199Selected && addon199Id) {
        const addon199Response = await cleanFetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: parseInt(addon199Id),
                quantity: quantity,
                properties: {
                  'Line 1': nameBottom1,
                  '_personalise_group': groupId,
                  'Bundle ID': groupId
                }
              }
            ]
          })
        });

        if (!addon199Response.ok) {
          const err = await addon199Response.json().catch(() => null);
          console.error('₹199 addon add failed:', err?.description || err);
        }
      }

      // LOGO — either the cheap default icon OR the paid custom
      // upload, never both. Which one fires depends on the radio
      // the customer picked.
      if (logoTypeSelected === 'icon' && logoIconName && logoIconId) {
        const logoIconResponse = await cleanFetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: parseInt(logoIconId),
                quantity: quantity,
                properties: {
                  'Icon': logoIconName,
                  '_personalise_group': groupId,
                  'Bundle ID': groupId
                }
              }
            ]
          })
        });

        if (!logoIconResponse.ok) {
          const err = await logoIconResponse.json().catch(() => null);
          console.error('Logo icon addon failed:', err?.description || err);
        }
      } else if (logoTypeSelected === 'custom' && logoFile && addon350Id) {
        // ₹350 CUSTOM LOGO ADDON (multipart request for the file)
        const formData350 = new FormData();
        formData350.append('id', addon350Id);
        formData350.append('quantity', String(quantity));
        formData350.append('properties[_personalise_group]', groupId);
        formData350.append('properties[Bundle ID]', groupId);
        formData350.append('properties[Logo File]', logoFile);

        const logoResponse = await cleanFetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: formData350
        });

        if (!logoResponse.ok) {
          const err = await logoResponse.json().catch(() => null);
          console.error('₹350 logo addon failed:', err?.description || err);
        }
      }

      // MATCHING SCRUB CAP (₹275) — full flow, only on templates that
      // have the Yes/No radio (customisation_2). The cap name (₹100)
      // and cap logo embroidery (₹350) addons only get added if the
      // cap itself was selected.
      if (hasCapToggle && isCapSelected && matchingCap275Id) {
        const capResponse = await cleanFetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: parseInt(matchingCap275Id),
                quantity: quantity,
                properties: {
                  '_personalise_group': groupId,
                  'Bundle ID': groupId
                }
              }
            ]
          })
        });

        if (!capResponse.ok) {
          const err = await capResponse.json().catch(() => null);
          console.error('Matching cap add failed:', err?.description || err);
        }

        // ₹100 CAP NAME ADDON — only if a name was entered
        if (capNameLine1.trim() && capAddon100Id) {
          const capNameResponse = await cleanFetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [
                {
                  id: parseInt(capAddon100Id),
                  quantity: quantity,
                  properties: {
                    'Name On Cap': capNameLine1,
                    '_personalise_group': groupId,
                    'Bundle ID': groupId
                  }
                }
              ]
            })
          });

          if (!capNameResponse.ok) {
            const err = await capNameResponse.json().catch(() => null);
            console.error('Cap name addon failed:', err?.description || err);
          }
        }

        // CAP LOGO — icon (cheap) vs custom upload (paid)
        await addCapLogoAddon(
          quantity, groupId, capLogoTypeSelected, capLogoIconId, capLogoIconName, capLogoFile, capAddon350Id
        );
      } else if (!hasCapToggle) {
        // NAME ON CAP (customisation_3 & 5, ₹100) — no Yes/No radio,
        // no matching cap product. Adds only when a name was typed.
        if (capNameLine1.trim() && capAddon100Id) {
          const capNameOnlyResponse = await cleanFetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [
                {
                  id: parseInt(capAddon100Id),
                  quantity: quantity,
                  properties: {
                    'Name On Cap': capNameLine1,
                    '_personalise_group': groupId,
                    'Bundle ID': groupId
                  }
                }
              ]
            })
          });

          if (!capNameOnlyResponse.ok) {
            const err = await capNameOnlyResponse.json().catch(() => null);
            console.error('Cap name addon failed:', err?.description || err);
          }
        }

        // CAP LOGO — icon (cheap) vs custom upload (paid). This
        // field doesn't exist on customisation_3, so capLogoTypeSelected
        // stays undefined there and this is simply skipped.
        await addCapLogoAddon(
          quantity, groupId, capLogoTypeSelected, capLogoIconId, capLogoIconName, capLogoFile, capAddon350Id
        );
      }

      await refreshCartUI();
      clearPersonaliseFields();
    } catch (error) {
      console.error('Add to cart error:', error);
    } finally {
      addToCartBtn.removeAttribute('aria-disabled');
      addToCartBtn.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    }
  });
});


/* ============================================================
 * QUANTITY SYNC ACROSS A GROUP
 * ============================================================ */
let isSyncingPersonaliseQuantity = false;

document.addEventListener('change', async function (e) {
  const quantityInput = e.target.closest(
    '.cart-item__quantity-wrapper input.quantity__input, input.quantity__input'
  );
  if (!quantityInput || isSyncingPersonaliseQuantity) return;

  const cartItem = quantityInput.closest('.cart-item');
  if (!cartItem) return;

  const line = parseInt(
    cartItem.dataset.index || cartItem.querySelector('[data-index]')?.dataset.index
  );
  if (!line) return;

  try {
    const response = await cleanFetch(window.Shopify.routes.root + 'cart.js', {
      cache: 'no-store'
    });
    const cart = await response.json();
    const item = cart.items[line - 1];
    if (!item) return;

    const groupId = item.properties?._personalise_group;
    if (!groupId) return; // normal product — leave it alone

    const newQuantity = parseInt(quantityInput.value) || 0;
    const updates = {};
    cart.items.forEach(function (cartItem) {
      if (cartItem.properties?._personalise_group === groupId) {
        updates[cartItem.key] = newQuantity;
      }
    });

    isSyncingPersonaliseQuantity = true;

    const updateResponse = await cleanFetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });

    if (!updateResponse.ok) {
      console.error('Quantity update failed');
      return;
    }

    await refreshCartUI();
  } catch (error) {
    console.error('Quantity sync error:', error);
  } finally {
    isSyncingPersonaliseQuantity = false;
  }
});


/* ============================================================
 * REMOVE ENTIRE GROUP
 * ============================================================
 * preventDefault/stopPropagation run SYNCHRONOUSLY (before any
 * await) so Dawn's own remove handler never gets a chance to
 * remove just the single line first. Group check reads the
 * `data-personalise-group` attribute that decoratePersonaliseCartItems()
 * already set on the .cart-item element — no fetch needed just
 * to decide whether to intercept.
 */
let isRemovingPersonaliseGroup = false;

document.addEventListener(
  'click',
  async function (e) {
    const removeButton = e.target.closest('.cart-remove-button');
    if (!removeButton || isRemovingPersonaliseGroup) return;

    const cartItem = removeButton.closest('.cart-item');
    if (!cartItem) return;

    const groupId = cartItem.getAttribute('data-personalise-group');
    if (!groupId) return; // normal product — let Dawn handle it

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    isRemovingPersonaliseGroup = true;

    try {
      const response = await cleanFetch(window.Shopify.routes.root + 'cart.js', {
        cache: 'no-store'
      });
      const cart = await response.json();

      const updates = {};
      cart.items.forEach(function (item) {
        if (item.properties?._personalise_group === groupId) {
          updates[item.key] = 0;
        }
      });

      const updateResponse = await cleanFetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });

      if (!updateResponse.ok) {
        console.error('Remove group failed:', await updateResponse.json().catch(() => null));
        return;
      }

      await refreshCartUI();
    } catch (error) {
      console.error('Remove personalisation error:', error);
    } finally {
      setTimeout(function () {
        isRemovingPersonaliseGroup = false;
      }, 300);
    }
  },
  true
);


/* ============================================================
 * GROUP ATTRIBUTE + CLASSES ON CART ITEMS
 * ============================================================ */

// data-index isn't always on .cart-item directly in this theme —
// it's often on a child (e.g. the quantity input). Check every
// place it can be before falling back to DOM order.
function getCartItemByIndex(line) {
  let cartItem = document.querySelector(`.cart-item[data-index="${line}"]`);
  if (cartItem) return cartItem;

  const indexEl = document.querySelector(`[data-index="${line}"]`);
  if (indexEl) {
    cartItem = indexEl.closest('.cart-item');
    if (cartItem) return cartItem;
  }

  const allCartItems = document.querySelectorAll('.cart-item');
  return allCartItems[line - 1] || null;
}

// Hides one line-item-property row (matched by its label text)
// inside a given cart item element — matches Dawn's markup:
// <div class="product-option"><dt>Label:</dt><dd>Value</dd></div>
// (note the colon is rendered as part of the <dt> text itself).
function hideCartPropertyRow(cartItemEl, label) {
  cartItemEl.querySelectorAll('.product-option').forEach(function (wrapper) {
    const dt = wrapper.querySelector('dt');
    if (!dt) return;

    const dtText = dt.textContent.trim().replace(/:$/, '');
    if (dtText === label) {
      wrapper.style.display = 'none';
    }
  });
}

// Pure DOM logic — takes cart data that's already been fetched
// and applies group classes/attribute synchronously, no network
// call of its own. Used right after a DOM swap so there's no gap
// between the new HTML appearing and it getting decorated (that
// gap was the visible "glitch" on quantity change/remove/add).
function applyGroupDecoration(cart) {
  const cartItems = document.querySelectorAll('.cart-item');
  if (!cartItems.length) return;

  cartItems.forEach(function (cartItem) {
    cartItem.classList.remove(
      'personalise-group-first',
      'personalise-group-middle',
      'personalise-group-last'
    );
    cartItem.removeAttribute('data-personalise-group');

    // "Bundle ID" is only meant for the store's own checkout /
    // order view — never show it in the cart itself.
    hideCartPropertyRow(cartItem, 'Bundle ID');
  });

  const groups = {};
  cart.items.forEach(function (item, index) {
    const groupId = item.properties?._personalise_group;
    if (!groupId) return;
    if (!groups[groupId]) groups[groupId] = [];
    groups[groupId].push(index + 1);
  });

  Object.keys(groups).forEach(function (groupId) {
    const lines = groups[groupId];

    // Skip solo items — a "group" of just the main product with
    // no addon/logo/cap attached isn't a real personalised bundle,
    // so it shouldn't get grouped classes or the attribute.
    if (lines.length < 2) return;

    lines.forEach(function (line, index) {
      const cartItem = getCartItemByIndex(line);
      if (!cartItem) return;

      cartItem.setAttribute('data-personalise-group', groupId);

      if (index === 0) {
        cartItem.classList.add('personalise-group-first');
      } else if (index === lines.length - 1) {
        cartItem.classList.add('personalise-group-last');
      } else {
        cartItem.classList.add('personalise-group-middle');
      }
    });
  });
}

let decorateToken = 0;

async function decoratePersonaliseCartItems() {
  const myToken = ++decorateToken;

  try {
    const response = await cleanFetch(window.Shopify.routes.root + 'cart.js', {
      cache: 'no-store'
    });
    const cart = await response.json();

    if (myToken !== decorateToken) return; // a newer call already started

    applyGroupDecoration(cart);
  } catch (error) {
    console.error('Cart decoration error:', error);
  }
}

document.addEventListener('DOMContentLoaded', decoratePersonaliseCartItems);

// Re-decorate whenever the cart drawer's own DOM changes (Dawn's
// AJAX re-render, other apps touching it, etc.) — scoped to just
// the cart-drawer element instead of the whole document.body, so
// unrelated page churn (widgets, animations, other scripts) doesn't
// trigger extra cart.js fetches that can race with our own updates.
let personaliseDecorateTimer = null;
function observeCartDrawer() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  const observer = new MutationObserver(function () {
    clearTimeout(personaliseDecorateTimer);
    personaliseDecorateTimer = setTimeout(decoratePersonaliseCartItems, 100);
  });
  observer.observe(cartDrawer, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', observeCartDrawer);
